import React from 'react';

function HeaderSettings({ settings, setSettings, uploading, uploadingField, handleSettingsImageUpload, handleSettingsImageDelete }) {
  return (
    <div className="editor-section">
      <h3>🏠 Header Settings</h3>
      <div className="form-group">
        <label>School Name</label>
        <input type="text" value={settings.schoolName} onChange={(e) => setSettings({...settings, schoolName: e.target.value})} className="form-input" />
      </div>
      <div className="form-group">
        <label>School Logo</label>
        {settings.logo && <img src={settings.logo} className="preview-img" />}
        <div style={{display:'flex',gap:10}}>
          <label className="upload-label">{uploading && uploadingField === 'logo' ? '⏳...' : '📷 Upload Logo'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleSettingsImageUpload('logo', e.target.files[0]); }} /></label>
          {settings.logo && <button className="remove-btn" onClick={() => handleSettingsImageDelete('logo', settings.logo)}>🗑️</button>}
        </div>
      </div>
      <div className="form-group">
        <label>Favicon</label>
        {settings.favicon && <img src={settings.favicon} className="preview-img-sm" />}
        <div style={{display:'flex',gap:10}}>
          <label className="upload-label">{uploading && uploadingField === 'favicon' ? '⏳...' : '📷 Upload Favicon'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleSettingsImageUpload('favicon', e.target.files[0]); }} /></label>
          {settings.favicon && <button className="remove-btn" onClick={() => handleSettingsImageDelete('favicon', settings.favicon)}>🗑️</button>}
        </div>
      </div>
      <div className="form-group">
        <label>Header BG Color</label>
        <input type="color" value={settings.headerBgColor} onChange={(e) => setSettings({...settings, headerBgColor: e.target.value})} className="form-input" style={{height:'40px'}} />
      </div>
      <div className="form-group">
        <label>Header Text Color</label>
        <input type="color" value={settings.headerTextColor} onChange={(e) => setSettings({...settings, headerTextColor: e.target.value})} className="form-input" style={{height:'40px'}} />
      </div>
      <div className="form-group">
        <label>Navigation Links</label>
        <div className="nav-links-editor">
          {(settings.navLinks || []).map((link, idx) => (
            <div key={idx} className="nav-link-item">
              <input value={link.name} onChange={(e) => { const nl = [...(settings.navLinks||[])]; nl[idx].name = e.target.value; setSettings({...settings, navLinks: nl}); }} placeholder="Link Name" className="form-input" />
              <input value={link.path} onChange={(e) => { const nl = [...(settings.navLinks||[])]; nl[idx].path = e.target.value; setSettings({...settings, navLinks: nl}); }} placeholder="Path" className="form-input" />
              <button className="remove-btn" onClick={() => setSettings({...settings, navLinks: (settings.navLinks||[]).filter((_,i)=>i!==idx)})}>🗑️</button>
            </div>
          ))}
          <button className="add-btn" onClick={() => setSettings({...settings, navLinks: [...(settings.navLinks||[]), { name: 'New Page', path: '/new-page' }]})}>+ Add Link</button>
        </div>
      </div>
    </div>
  );
}

export default HeaderSettings;